import { assignViewsState, callOnLoadOnColumns } from "../../../other/utils/otherUtils";
import {getRowHeight} from "../../../react/context/bryntumContext.jsx";
import { defaultCellRenderer, defaultGroupRenderer as groupRenderer } from "../../../other/utils/utils.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { SWIVU_ASSIST_CONFIG } from "../../../other/constants/OtherKeys.jsx";
import { ENTITY_TYPES } from "@/other/constants/OtherKeys";

export const HasTaskHistoryBaseMixin = (target) =>
  class extends target {
    static get $name() {
      return "HasTaskHistoryBaseMixin";
    }
    static get configurable() {
      return {
        title: "History",
        defaults: {
          labelWidth: 104
        },
        items: {
          taskHistoryGrid: {
            emptyText: "No scheduling data yet.",
            type: WIDGET_KEYS.swivuModernGrid,
            height: "100%",
            ui: "taskHistoryGrid",
            onCellDblClick: "up.onTaskClick",
            features: {
              stripe: true,
              cellEdit: false,
              sort: {
                field: "startDate",
                multiSort: false
              },
              cellMenu: false,
            },
            columns: [
              {
                id: "name",
                field: "name",
                text: "Task Name",
                align: "left",
                flex: 1,
                type: "unplannedTask",
                cellCls: "b-sch-horizontal"
              },
              {
                id: "startDate",
                type: "date",
                text: "Start date",
                field: "startDate",
                flex: 1
              },
              {
                id: "startTime",
                type: "time",
                text: "Start time",
                field: "startDate",
                editor: {
                  keepDate: true
                },
                flex: 1
              },
              {
                id: "duration",
                field: "duration",
                text: "Duration",
                flex: 1
              },
              {
                id: "endDate",
                type: "date",
                text: "End date",
                field: "endDate",
                flex: 1
              },
              {
                id: "endTime",
                type: "time",
                text: "End time",
                field: "endDate",
                editor: {
                  keepDate: true
                },
                flex: 1
              },
              {
                id: "status",
                field: "status",
                type: WIDGET_KEYS.swivuSortColumn,
                text: "Status",
                align: "left",
                renderer: defaultCellRenderer,
                flex: 1,
                groupRenderer
              }
            ]
          }
        },
        swivuAssistance: SWIVU_ASSIST_CONFIG.history
      };
    }

    loadRecord(record, context) {
      super.loadRecord(record, context);

      const { taskHistoryGrid } = this.widgetMap;
      taskHistoryGrid.rowHeight = getRowHeight();
      assignViewsState([taskHistoryGrid], this.stateProvider);
      callOnLoadOnColumns(taskHistoryGrid.columns, context.project, context);
    }

    onTaskClick({ record }) {
      this.context.entityManager.openEntityManager({ entityType: ENTITY_TYPES.TASK, entityId: record.task.id });
    }
  };
